import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { FundSource } from 'src/app/model/fund-source';
import { UntypedFormGroup } from '@angular/forms';
import { AlertModal } from 'src/app/model/alert';

import * as DataConfig from '../../pages/user-details/config/user-data.config';
import { CurrencyFunctionalityService, DealPartnerFunctionalityService, AnalyticsService, UtilService } from 'src/app/shared';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-pension-source',
  templateUrl: './pension-source.component.html',
  styleUrls: ['./pension-source.component.scss']
})

export class PensionSourceComponent implements OnInit, OnChanges {

  @Input() sourceConfig: FundSource;
  @Input() parent: UntypedFormGroup;
  @Input() parentControlName: string;
  @Input() sourceSelected;
  @Input() minprodCodeLength;
  @Input() length;
  @Output() currencyValueChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() productCodeChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() onChangeHandler: EventEmitter<any> = new EventEmitter<any>();
  @Output() addProductCodeControllerName: EventEmitter<any> = new EventEmitter<any>();
  @Output() removeProductCodeControllerName: EventEmitter<any> = new EventEmitter<any>();
  @Input() productCodeSelected;
  @Input() pensionFundConfig;

  @Output() GACodeEmitter = new EventEmitter();
  @Output() productCodeEmitter = new EventEmitter();
  @Output() onDisplayMobileTooltipEmitter: EventEmitter<any> = new EventEmitter<any>();


  public fundConfig = Object.assign({}, DataConfig.ElementsConfig.fundValueConfig);
  public productCodeConfig = Object.assign({}, DataConfig.ElementsConfig.productCodeConfig);
  public fundAmount = 0;
  public contentData;
  isDealPartnerWithoutProductCode: boolean;
  cmsData: any;
  public screenName: string;
  public pensionFundData;
  tooltipModal;
  public tooltipModalConfig: AlertModal;
  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private analyticsService: AnalyticsService,
    private utilService: UtilService) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.yourPension;
    this.tooltipModal = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
  }

  ngOnInit() {
    this.pensionFundData = this.pensionFundConfig;
    this.setConfig('init');
    this.tooltipModalConfig = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
  }
  ngOnChanges() {
    this.setConfig('change');
  }
  setConfig(type) {
    if (type === 'init') {
      this.fundConfig.minValue = this.pensionFundData.minValue ? this.pensionFundData.minValue : null;
      this.fundConfig.maxValue = this.pensionFundData.maxValue ? this.pensionFundData.maxValue : null;
    }
    this.fundConfig.name = this.parentControlName + this.fundConfig.controlName;
    this.fundConfig.value = (this.parent && this.parent.value) ? (this.parent.value.fundValue ? this.parent.value.fundValue : '') : '';
    this.fundAmount = CurrencyFunctionalityService.convertCurrencyToNumber(this.fundConfig.value);
    this.productCodeConfig.label = this.sourceConfig.productCodeLabel;
    this.productCodeConfig.name = this.parentControlName + this.productCodeConfig.controlName;
    this.productCodeConfig.value = (this.parent && this.parent.value) ? (this.parent.value.productCode ? this.parent.value.productCode : '')
      : '';
    this.isDealPartnerWithoutProductCode = DealPartnerFunctionalityService.isDealPartnerWithoutProductCode(this.sourceSelected.value);
  }

  currencyChangeHandler(val) {
    this.fundAmount = CurrencyFunctionalityService.convertCurrencyToNumber(val);
    this.currencyValueChanged.emit(true);
    //this.onChangeHandler.emit();
    if (this.parent.controls['productCode']['controls'].length == 0) {
      this.parent.controls['productCode']['controls'].push(this.productCodeSelected)
    }
  }

  productCodeChangeHandler(code) { 
    this.productCodeChanged.emit({ event:this.parentControlName, ui: code });
  }
  currenyChangeChildHandler() {
    this.onChangeHandler.emit();
  }
  getID(id_value) {
    let s;
    s = id_value.replace(/\s/g, '');
    // s=s.charAt(0).toLowerCase() + s.substr(1);
    return s;
  }
  addInsertRecords() {
    /*
    //console.log('sasasasasasasasa=>',this.productCodeConfig);
    const addControlFromConfig= JSON.parse(JSON.stringify( this.productCodeConfig));
    addControlFromConfig['controlName'] = 'productCode'+this.Index;
    addControlFromConfig['name'] = 'productCode'+this.Index;
    addControlFromConfig['value'] = '';
   
    this.insertContractCode.push(addControlFromConfig);
    */
    this.addProductCodeControllerName.emit('productCode');
  }

  removeConractCode(index) {
    this.removeProductCodeControllerName.emit(index)
  }
  contractCodeReceiver(val) {
    if (this.parentControlName === "aegon") {
      this.analyticsService.eventTrack({ type: 'Question', name: val, pageID: this.getCurrentScreenURL() });
    }
  }
  GACodeReceiver(val) {
    if (this.parentControlName === 'sunLife') {
      this.analyticsService.eventTrack({ type: 'Question', name: val, pageID: this.getCurrentScreenURL() });
    }    
    if (this.parentControlName === 'phoenixLife') {
      this.analyticsService.eventTrack({ type: 'Question', name: val, pageID: this.getCurrentScreenURL() });
    }
  }
  productCodeReceiver(val) {
    this.productCodeEmitter.emit(val);

  }

  getCurrentScreenURL() {
    this.screenName = this.utilService.getScreenNameFromURL(this.router.url);
    return this.screenName;
  }

  displayTooltipMessage(){
    this.onDisplayMobileTooltipEmitter.emit();
  }
}
